// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__157aF","question":"Question_question__2fDrg","description":"Question_description__2qzc-"};